import { Container, DisplayObject, Point, Ticker } from 'pixi.js'
import SnowFlakeParticle from './SnowFlakeParticle'
import { interpolate } from '../../../utils/math'

const snowIntensity = 0.3 //0-1
const flakeSpeed = 1.5

//if intensity parameter  = 0 then min values are used, if intensity = 1 max values are used, otherwise interpolated
// const particleContainerSizeRange = { min: 1500, max: 6000 };
const minParticlesRange = { min: 200, max: 400 }
const maxParticlesRange = { min: 1500, max: 4000 }
const minDelayRange = { min: 15, max: 6 }
const maxDelayRange = { min: 180, max: 90 }

export default class Snow extends Container {
  private flakeDelay: number
  private numFlakes: number
  private particleContainer: Container

  private flakeLast: number = 0
  private flakesActive: SnowFlakeParticle[]
  private flakesPool: SnowFlakeParticle[]
  private loopDirection: number = 0
  private containerWidth: number
  private containerHeight: number

  constructor(position: Point, containerWidth: number = 100, containerHeight: number = 100, intensity: number = 0) {
    super()
    this.zIndex = 1

    this.containerWidth = containerWidth
    this.containerHeight = containerHeight

    // const particleContainerSize: number = interpolate(
    //   particleContainerSizeRange.min,
    //   particleContainerSizeRange.max,
    //   intensity,
    // );
    const flakesMin: number = interpolate(minParticlesRange.min, minParticlesRange.max, intensity)
    const flakesMax: number = interpolate(maxParticlesRange.min, maxParticlesRange.max, intensity)
    const delayMin: number = interpolate(minDelayRange.min, minDelayRange.max, intensity)
    const delayMax: number = interpolate(maxDelayRange.min, maxDelayRange.max, intensity)

    this.flakeDelay = (delayMax - (delayMax - delayMin) * snowIntensity) / flakeSpeed / 50
    this.numFlakes = Math.round(flakesMin + (flakesMax - flakesMin) * snowIntensity)

    this.flakeLast = 0
    this.flakesActive = []
    this.flakesPool = []
    this.loopDirection = 0

    this.particleContainer = new Container()

    this.particleContainer.x = position.x
    this.particleContainer.y = position.y
    this.addChild(this.particleContainer as DisplayObject)

    this.resetFlakes()

    const ticker = Ticker.shared
    ticker.add((ms) => this.loop(ms))
  }

  private resetFlakes(): void {
    this.flakesActive.forEach((flake: SnowFlakeParticle) => {
      flake.remove()
      this.flakesPool.push(flake)
    })
    this.flakesActive = []
    for (let i = 0; i < this.numFlakes; i++) {
      this.addFlake(true)
    }
  }

  private addFlake(randomY: boolean) {
    const flake: SnowFlakeParticle =
      this.flakesPool.pop() || new SnowFlakeParticle(this.particleContainer, this.containerWidth, this.containerHeight)
    flake.reset(randomY)
    this.flakesActive.push(flake)
  }

  private loop(ms: number): void {
    this.loopDirection = (this.loopDirection + ms) % 100000
    this.moveFlakes(
      //0.6 * Math.sin((this.loopDirection / 100000 - 0.5) * 4 * Math.PI)
      0,
    )
    this.addFlakes(ms)
  }

  private moveFlakes(xDirection: number): void {
    const movingFlakes: SnowFlakeParticle[] = []
    this.flakesActive.forEach((flake) => {
      if (flake.move(flakeSpeed, xDirection)) {
        //0 or xDirection
        movingFlakes.push(flake)
      } else {
        this.flakesPool.push(flake)
      }
    })
    this.flakesActive = movingFlakes
  }

  private addFlakes(msFrame: number): void {
    this.flakeLast += msFrame

    while (this.flakeLast > this.flakeDelay) {
      this.flakeLast -= this.flakeDelay
      this.addFlake(false)
    }
  }
}
